import type { MobileAction, MobileEvidence, MobileEvidenceReference } from "@/lib/mobile/offline-queue";

type Dependencies = {
  markUploaded: (evidenceId: string, fileId: string) => Promise<void>;
  readEvidence: (evidenceId: string) => Promise<MobileEvidence | null>;
  uploadEvidence: (action: MobileAction, evidence: MobileEvidence) => Promise<string>;
};

export async function prepareMobileActionsForSync(actions: MobileAction[], dependencies: Dependencies) {
  const prepared: MobileAction[] = [];
  for (const action of actions) prepared.push(await prepareAction(action, dependencies));
  return prepared;
}

async function prepareAction(action: MobileAction, dependencies: Dependencies): Promise<MobileAction> {
  if (!Array.isArray(action.payload.offlineEvidence) || !["driver.stop_execution", "safety.form_submission"].includes(action.type)) return action;
  const payload = { ...action.payload };
  const references = action.payload.offlineEvidence as MobileEvidenceReference[];
  for (const reference of references) {
    const evidence = await dependencies.readEvidence(reference.id);
    if (!evidence || evidence.actionId !== action.id || evidence.field !== reference.field) throw new Error("Queued delivery evidence is unavailable");
    let fileId = evidence.uploadedFileId;
    if (!fileId) {
      fileId = await dependencies.uploadEvidence(action, evidence);
      await dependencies.markUploaded(evidence.id, fileId);
    }
    if (action.type === "safety.form_submission") payload.fileIds = [...(Array.isArray(payload.fileIds) ? payload.fileIds : []), fileId];
    else if (reference.field === "photoFileIds") payload.photoFileIds = [...(Array.isArray(payload.photoFileIds) ? payload.photoFileIds : []), fileId];
    else payload[reference.field] = fileId;
  }
  delete payload.offlineEvidence;
  return { ...action, payload };
}
